import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { z } from 'zod';
import type { ApiResponse } from '@/types/api-types';
import type { paths } from '~/generated/tenant-basic/api-schema';
import { tenantBasicApi } from '@/services';

const API_PATH = '/v1/shiftPeriod/queryDisplayTime' as const;
const QUERY_SHIFT_PERIOD_DISPLAY_TIME_KEY = API_PATH;

const shiftPeriodDisplayTimeSchema = z.object({
  NIGHT: z.string(),
  DAY: z.string(),
  EVENING: z.string(),
});

type APIResponse = ApiResponse<paths, typeof API_PATH>;

const queryFn = async (signal: AbortSignal) => {
  const { data: response } = await tenantBasicApi.get<APIResponse>(API_PATH, {
    signal,
  });

  return shiftPeriodDisplayTimeSchema.parse(response.data);
};

export const getQueryShiftPeriodDisplayTimeOptions = () =>
  queryOptions({
    queryKey: [QUERY_SHIFT_PERIOD_DISPLAY_TIME_KEY] as const,
    queryFn: ({ signal }) => queryFn(signal),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });

export const useSuspenseQueryShiftPeriodDisplayTime = () =>
  useSuspenseQuery(getQueryShiftPeriodDisplayTimeOptions());
